import en from './locales/en.json';
import fr from './locales/fr.json';

export default {
  en: en,
  fr: {
    ...en,
    ...fr
  },
}
